
import DATAANALYSIS from './modules/dataAnalysis/index';

const apiUrl = {
  DATAANALYSIS
};
export default {
  install(Vue) {
    Vue.prototype.$apiUrl = apiUrl;
    Vue.apiUrl = apiUrl;
  }
};



// WEBPACK FOOTER //
// ./src/data/apiUrl/index.js